var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 17,
    viewBox: "0 0 77 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_14690)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9703 14.5811C34.2456 14.5811 33.6659 13.9144 33.6659 13.0737C33.6659 12.2041 34.2456 11.6243 34.9703 11.6243H43.2898V12.7838C43.2976 13.0123 43.2602 13.24 43.1799 13.454C43.0996 13.668 42.9778 13.864 42.8217 14.0309C42.6656 14.1979 42.478 14.3324 42.2699 14.4268C42.0617 14.5212 41.837 14.5736 41.6085 14.5811H34.9703ZM41.6085 4.26141H31.5208V6.49348H41.6085C42.5651 6.46449 43.3478 7.24716 43.2898 8.29072V9.36327H34.9703C33.0571 9.36327 31.5208 10.9866 31.4918 13.0447C31.5208 15.0739 33.0571 16.7552 34.9703 16.7552H41.6085C43.7536 16.7552 45.4349 14.9289 45.4639 12.7259V8.29072C45.4349 6.05866 43.7536 4.23242 41.6085 4.26141ZM58.7114 4.26141H60.8565V12.6969C60.8275 14.9579 59.1172 16.7552 56.9431 16.7552H47.0872V14.5811H56.9431C57.8997 14.5811 58.6824 13.7115 58.6824 12.6969V11.6823H50.9426C48.7975 11.6823 47.0872 9.82708 47.0872 7.56603V4.26141H49.2613V7.53704C49.2323 8.55161 49.986 9.39226 50.9136 9.39226H58.7114V4.26141ZM19.7807 14.5811C18.8531 14.5811 18.0994 13.7694 18.0704 12.7549V11.6243H26.4769C27.1726 11.6243 27.7523 12.2041 27.7234 13.0737C27.7234 13.9144 27.1726 14.5811 26.4769 14.5811H19.7807ZM18.0704 9.39226V4.26141H15.9253V12.7549C15.9253 14.9579 17.6646 16.7842 19.7807 16.7842H26.4769C28.3611 16.7842 29.8974 15.1029 29.8685 13.0737C29.8685 11.0446 28.3611 9.36327 26.4769 9.39226H18.0704ZM76.1911 9.39226V11.6533H64.6249V12.6969C64.5959 13.7404 65.4076 14.5811 66.3642 14.5811H76.1621V16.7842H66.3642C64.2191 16.7842 62.5088 14.9579 62.4798 12.7259V4.23242H64.6249V9.36327L76.1911 9.39226Z",
    fill: "#0070EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.282715 5.8853L7.21081 2.23283L14.1099 5.82732V4.23299L7.2398 0.66748L0.282715 4.26198V5.8853Z",
    fill: "#FFD42A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_14690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.9192,
    height: 16.1173,
    fill: "white",
    transform: "translate(0.284668 0.66748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner3);
export default __webpack_public_path__ + "static/media/partner-3.fed1e0f6626c80deb5f91bae6905141b.svg";
export { ForwardRef as ReactComponent };